import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { StoreProvider } from "./store";
import { MainView } from "./views/MainView";
import { KioskLayout } from "./components/KioskLayout/KioskLayout";
import LanguageSelector from "./components/LanguageSelector/LanguageSelector";

import "./i18n";

import "./global/default.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <StoreProvider>
      <KioskLayout>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<MainView />} />
          </Routes>
        </BrowserRouter>
        <LanguageSelector />
      </KioskLayout>
    </StoreProvider>
  </React.StrictMode>
);
